import { Directive, HostListener, Input } from '@angular/core';
import { MatSelect } from '@angular/material/select';

@Directive({
  selector: '[readonlySelect]'
})
export class ReadonlySelectDirective {
@Input() readonlySelect = false;

  constructor(private matSelect: MatSelect) {}

  @HostListener('openedChange', ['$event'])
  onOpenedChange(opened: boolean): void {
    if (opened && this.readonlySelect) {
      this.matSelect.close();
    }
  }
}